import Vue from 'vue'

export function getInputElement(el) {
  let result
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input')
    if (els.length !== 1) {
      throw new Error('Masking requires at least 1 input')
    } else {
      result = els[0]
    }
  } else {
    result = el
  }
  return result
}

// Fires an input event (so vue will take care of the binding to the model)
export function event(name) {
  var evt = document.createEvent('Event')
  evt.initEvent(name, true, true)
  return evt
}
// Insert html element after targetElement
export function insertAfter(newElement, targetElement) {
  Vue.nextTick(() => {
    // target is what you want it to go after. Look for this elements parent.
    var parent = targetElement.parentNode

    // if the parents lastchild is the targetElement...
    if (parent.lastChild === targetElement) {
      // add the newElement after the target element.
      parent.appendChild(newElement)
    } else {
      // else the target has siblings, insert the new element between the target and it's next sibling.
      parent.insertBefore(newElement, targetElement.nextSibling)
    }
  })
}

// Add a hidden input field (for cleave.js to perform its masking)
export function createMaskElement(uniqueClassName) {
  const maskPnl = document.createElement('div')
  maskPnl.className = 'maskPnl'
  const maskElement = document.createElement('input')
  maskElement.className = 'maskInput ' + uniqueClassName
  maskPnl.appendChild(maskElement)
  return maskPnl
}

// Generate random class name (to work with cleave.js input field)
export function generateClassName() {
  const charSet = 'abcdefghijklmnopqrstuvwxyz'
  var randomString = ''
  for (var i = 0; i < 10; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length)
    randomString += charSet.substring(randomPoz, randomPoz + 1)
  }
  return randomString
}
